module.exports = __webpack_public_path__ + "img/taisiev icon 1.9e75bfc9.png";